"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getManyCustomerReadOnlyBomOutputDtoSchema = exports.getManyCustomerReadOnlyBomInputDtoSchema = exports.customerReadOnlyBomSortSchema = exports.customerReadOnlyBomSortOrderSchema = exports.customerReadOnlyBomSortFieldSchema = exports.customerReadOnlyBomFilterSchema = void 0;
const z = __importStar(require("zod"));
const cadstrom_shared_1 = require("@cadstrom/cadstrom-shared");
exports.customerReadOnlyBomFilterSchema = cadstrom_shared_1.QueryBuilder.createFilterSchema({
    fields: {
        referenceDesignator: {
            description: 'Reference designator of the BOM item (e.g. U1, R3). Case-insensitive substring match.',
            options: { type: cadstrom_shared_1.QueryBuilder.FieldType.String, nonNullable: true },
            allowedOperators: ['contains'],
        },
    },
});
exports.customerReadOnlyBomSortFieldSchema = z.enum(['pinCount', 'referenceDesignator']);
exports.customerReadOnlyBomSortOrderSchema = z.enum(['asc', 'desc']);
exports.customerReadOnlyBomSortSchema = z.object({
    field: exports.customerReadOnlyBomSortFieldSchema,
    order: exports.customerReadOnlyBomSortOrderSchema,
});
exports.getManyCustomerReadOnlyBomInputDtoSchema = z.object({
    buildId: z.string(),
    cursor: z.string().optional(),
    limit: z.number().int().positive().max(2000).optional(),
    sort: exports.customerReadOnlyBomSortSchema.optional().describe('Server-side sort; defaults to pin count descending.'),
    filters: cadstrom_shared_1.QueryBuilder.createColumnFilterZodSchema(exports.customerReadOnlyBomFilterSchema).optional(),
    filterLogicOperator: cadstrom_shared_1.QueryBuilder.logicOperatorSchema
        .optional()
        .describe('How to combine filters. Defaults to "and".'),
});
exports.getManyCustomerReadOnlyBomOutputDtoSchema = z.object({
    items: cadstrom_shared_1.customerReadOnlyBomItemWithStaticMetadataSchema.array(),
    nextCursor: z.string().nullable(),
    hasNextPage: z.boolean(),
});
//# sourceMappingURL=get-many.js.map